import React              from 'react';
import PartNumber         from 'pu-react/components/PartNumber';
import StencilFile        from 'pu-react/components/StencilFile';
import StencilThickness   from 'pu-react/components/StencilThickness';
import StencilLengthText  from 'pu-react/components/StencilLengthText';
import StencilWidthText   from 'pu-react/components/StencilWidthText';
import StencilsBorder     from 'pu-react/components/StencilsBorder';
import StencilSide     from 'pu-react/components/StencilSide';
import PrintConfirmation  from 'pu-react/components/PrintConfirmation';
import SpecialInstruction from 'pu-react/components/SpecialInstruction';
import ProductQuoteNumber from 'pu-react/components/ProductQuoteNumber';
import RowSelected        from 'pu-react/components/RowSelected';
import ColumnSelected     from 'pu-react/components/ColumnSelected';
import Quantity           from './form/Quantity';
import AdditionalInfo     from './form/AdditionalInfo';

import { stencilThickness as stencilThicknessOptions } from '../data/SelectOptions';

export default (props) => {

  const onChangeParameter = (name, value) => {
    const authToken = document.getElementsByName('authenticity_token')[0].value;
    const variantId = document.getElementsByName('variant_id')[0].value;
    props.onChangeParameterAndQuote(name, value, authToken, variantId);
  };

  return (
    <div className="pcb-form-section">
      <div className="text-end form-group required">
        * Required information
      </div>
      <div className="row">
        <div className="col-md-12">
          <Quantity {...props} />
          <PartNumber {...props} />
        </div>
        <div className="col-md-12">
          <StencilFile required {...props} />
        </div>
        <div className="col-md-12">
          <StencilThickness required {...props} options={stencilThicknessOptions} inputClassName="ignore-on-quote" />
        </div>
        <div className="col-md-12">
          <StencilSide required {...props} inputClassName="ignore-on-quote" />
        </div>
        <div className="col-md-6">
          <StencilLengthText {...props} onChangeParameter={onChangeParameter} />
        </div>
        <div className="col-md-6">
          <StencilWidthText {...props} onChangeParameter={onChangeParameter} />
        </div>
        <div className="col-md-12">
          <StencilsBorder {...props} onChangeParameter={onChangeParameter} />
        </div>
        <div className="col-md-12">
          <PrintConfirmation required {...props} inputClassName="ignore-on-quote" />
        </div>
        <div className="col-md-12">
          <SpecialInstruction {...props} />
        </div>
        <div className="col-md-12">
          <AdditionalInfo />
        </div>
        <RowSelected {...props} />
        <ColumnSelected {...props} />
        <ProductQuoteNumber {...props} />
      </div>
    </div>
  );
};
